import { NgModule } from '@angular/core';

import { HlmAccordionContentComponent } from './lib/hlm-accordion-content.component';
import { HlmAccordionIconDirective } from './lib/hlm-accordion-icon.directive';
import { HlmAccordionItemDirective } from './lib/hlm-accordion-item.directive';
import { HlmAccordionTrigger } from './lib/hlm-accordion-trigger.directive';
import { HlmAccordionDirective } from './lib/hlm-accordion.directive';

export * from './lib/hlm-accordion-content.component';
export * from './lib/hlm-accordion-icon.directive';
export * from './lib/hlm-accordion-item.directive';
export * from './lib/hlm-accordion-trigger.directive';
export * from './lib/hlm-accordion.directive';

export const HlmAccordionImports = [
  HlmAccordionDirective,
  HlmAccordionItemDirective,
  HlmAccordionTrigger,
  HlmAccordionIconDirective,
  HlmAccordionContentComponent,
] as const;

@NgModule({
  imports: [...HlmAccordionImports],
  exports: [...HlmAccordionImports],
})
export class HlmAccordionModule {}
